import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../Pictures/logo.png';
import '../styles/TrainersNavbar.css'; // Import CSS file for TrainersNavbar
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const TrainersNavbar = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isTrainerLoggedIn');
    localStorage.removeItem('trainerName');
    navigate('/');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="navbar">
      <nav className="container mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <NavLink to="/" className="flex items-center">
          <img src={logo} alt="Logo" className="w-12 h-12" />
          <span className="ml-2 text-xl font-bold text-White-800">Trainer</span>
        </NavLink>

        {/* Navbar Links */}
        <div className="hidden md:flex space-x-6">
          <NavLink
            to="/trainer-dashboard"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'text-blue-500' : ''}`
            }
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/trainer-students"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'text-blue-500' : ''}`
            }
          >
            Students
          </NavLink>
          <NavLink
            to="/trainer-timetable"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'text-blue-500' : ''}`
            }
          >
            Timetable
          </NavLink>
          <NavLink
            to="/trainer-message"
            className={({ isActive }) =>
              `nav-link ${isActive ? 'text-blue-500' : ''}`
            }
          >
            Messages
          </NavLink>
          <button
            onClick={handleLogout}
            className="nav-link"
          >
            <FontAwesomeIcon icon={faSignOutAlt} /> Logout
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button
          type="button"
          className="block md:hidden text-gray-800 focus:outline-none"
          onClick={toggleMenu}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>
      </nav>

      {/* Mobile Menu */}
      <div className={`md:hidden ${isMenuOpen ? '' : 'hidden'} bg-white shadow-md`}>
        <NavLink
          to="/trainer-dashboard"
          className={({ isActive }) =>
            `block px-4 py-2 text-gray-600 hover:bg-blue-100 ${isActive ? 'bg-blue-100' : ''}`
          }
        >
          Dashboard
        </NavLink>
        <NavLink
          to="/trainer-students"
          className={({ isActive }) =>
            `block px-4 py-2 text-gray-600 hover:bg-blue-100 ${isActive ? 'bg-blue-100' : ''}`
          }
        >
          Students
        </NavLink>
        <NavLink
          to="/trainer-timetable"
          className={({ isActive }) =>
            `block px-4 py-2 text-gray-600 hover:bg-blue-100 ${isActive ? 'bg-blue-100' : ''}`
          }
        >
          Timetable
        </NavLink>
        <NavLink
          to="/trainer-message"
          className={({ isActive }) =>
            `block px-4 py-2 text-gray-600 hover:bg-blue-100 ${isActive ? 'bg-blue-100' : ''}`
          }
        >
          Messages
        </NavLink>
        <button
          onClick={handleLogout}
          className="block px-4 py-2 text-gray-600 hover:bg-blue-100"
        >
          <FontAwesomeIcon icon={faSignOutAlt} /> Logout
        </button>
      </div>
    </div>
  );
};

export default TrainersNavbar;
